<template>
  <div class="screenshare-instructions tv tv-list">
    <div class="tv-cell tv-cell-default caption-type">
      <base-icon name="watch_ios" />
      <span>{{ timeLimitText }}</span>
    </div>
    <div class="tv-cell tv-cell-default caption-type">
      <base-icon name="screen_ios" />
      <span>
        <span v-if="isChrome">
          {{
            __(
              "You can record the whole screen, an application window, or another browser tab. You'll select what to record in the next step.",
            )
          }}
        </span>
        <span v-if="isFirefox">
          {{
            __(
              'You can record a screen, or an application window. You’ll select which screen or window to record in the next step.',
            )
          }}
        </span>
      </span>
    </div>
    <div class="tv-cell tv-cell-default caption-type">
      <base-icon name="audio_ios" />
      <span>{{ __('You can record with or without audio.') }}</span>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import BaseIcon from 'vuecomponents/base_icon'
import device from 'bits/device'
import { mapState } from 'vuex'
export default {
  components: { BaseIcon },
  props: ['audioDevices', 'activeAudioDeviceId'],
  methods: {
    chooseAudioDevice(e) {
      this.$emit('choose-audio-device', e)
    },
  },
  computed: {
    ...mapState(['isChrome', 'isFirefox']),
    timeLimitText() {
      const translatedLimit = this.__('%{num} minutes', { num: '5' })
      return this.__('You can record for up to %{timeLimit}. Recording will stop automatically at %{timeLimit}.', {
        timeLimit: translatedLimit,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import './../../assets/stylesheets/3/modules/all';
.screenshare-instructions {
  padding: 16px 24px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}
.tv-cell {
  min-height: unset;
  align-items: flex-start;
}
i {
  font-size: 18px;
  line-height: 22.4px;
}
</style>
